import { SupportViewKeySchema, type SupportViewKey } from "../../shared/support-schemas";

/** The support desk's addresses: a view, unmatched mail, AI settings, or one ticket (ADR-0089). */
export type SupportRoute =
  | { kind: "view"; view: SupportViewKey }
  | { kind: "unmatched" }
  | { kind: "settings" }
  | { kind: "ticket"; ticketId: string };

export function parseSupportRoute(path: string): SupportRoute | null {
  if (path === "/support") return { kind: "view", view: "open" };
  if (path === "/support/unmatched") return { kind: "unmatched" };
  if (path === "/support/settings") return { kind: "settings" };
  const view = /^\/support\/views\/([a-z_]+)$/u.exec(path)?.[1];
  if (view !== undefined) {
    const parsed = SupportViewKeySchema.safeParse(view);
    return parsed.success ? { kind: "view", view: parsed.data } : null;
  }
  const ticketId = /^\/support\/tickets\/([a-z][a-z0-9_]{4,127})$/u.exec(path)?.[1];
  return ticketId === undefined ? null : { kind: "ticket", ticketId };
}

export function supportViewPath(view: SupportViewKey): string {
  return view === "open" ? "/support" : `/support/views/${view}`;
}

export const supportTicketPath = (ticketId: string) =>
  `/support/tickets/${encodeURIComponent(ticketId)}`;
